import { memo } from 'react';
import { PropertyInputHighlySensitiveFloating } from './highlySensitive/PropertyInputHighlySensitiveFloating';
import { PropertyInputHighlySensitiveNonFloating } from './highlySensitive/PropertyInputHighlySensitiveNonFloating/PropertyInputHighlySensitiveNonFloating';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyInputHighlySensitive = props => {
  useComponentMountMetric('PropertyInputHighlySensitive');
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (props.use === 'floating') {
    return /*#__PURE__*/_jsx(PropertyInputHighlySensitiveFloating, Object.assign({}, props, {
      displayOptimized: isUngatedForDisplayOptimizedFormControl
    }));
  }
  return /*#__PURE__*/_jsx(PropertyInputHighlySensitiveNonFloating, Object.assign({}, props, {
    displayOptimized: isUngatedForDisplayOptimizedFormControl
  }));
};
export default /*#__PURE__*/memo(PropertyInputHighlySensitive);